<template>
  <div class="container_box">
    <banner title="联系我们" text="联系我们获取最优质的包装服务" imgUrl="https://manybox.oss-cn-shanghai.aliyuncs.com/officialWebsite/banner5.png"></banner>

    <!-- 联系我们 -->
    <div class="box-con">
      <div class="con">
        <div class="ours-box">
          <div class="ours-title-left">
            <div class="line-box"></div>
            <h3>{{ $t('nav.contactus') }}</h3>
            <p>
              <!-- {{ $t('about.title1') }} -->
              沃时派客是国内领先的数字化包装管理创新平台。我们致力于通过互联网技术实现对包装供应链的方案设计
            </p>
            <div class="icon">
              <img src="@/assets/ours/address.png" alt="">
              <span class="small-font">{{ $t('common.addressStr') }}</span>
            </div>
            <div class="icon">
              <img src="@/assets/ours/email.png" alt="">
              <span class="small-font">sales@worthtec.com</span>
            </div>
            <div class="icon">
              <img src="@/assets/ours/phone.png" alt="">
              <span class="small-font">400 821 3731</span>
            </div>
          </div>
          <div class="mapbox">
            <baidu-map class="map" :center="center" :zoom="zoom" :scroll-wheel-zoom="true" @ready="handler">
              <bm-marker :position="{lng: 121.272618, lat: 31.200839}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
              </bm-marker>
            </baidu-map>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from './banner.vue'

export default {
  components: {
    banner
  },

  data () {
    return {
      center: { lng: 121.272618, lat: 31.200839 },
      zoom: 20
    };
  },
  created () {
  },
  methods: {
    handler ({ BMap, map }) {
      console.log(BMap, map)
      this.center.lng = 121.272618
      this.center.lat = 31.200839
      this.zoom = 15
    },
  }
};
</script>

<style lang="less" scoped>
.container_box {
  width: 100%;
  background: #fff;
  // height: 750px;
  .box-con {
    // position: relative;
    // bottom: 48px;
    display: flex;
    justify-content: center;
    .con {
      width: 1200px;
      // height: 757px;
      background: #ffffff;
      .ours-box {
        margin: 138px 84px 100px;
        display: flex;
        .ours-title-left {
          width: 433px;
          height: 519px;

          .line-box {
            width: 50px;
            height: 2px;
            background: #000000;
            margin-bottom: 24px;
          }
          h3 {
            height: 50px;
            font-size: 36px;
            color: #000000;
            line-height: 50px;
            margin-bottom: 32px;
          }
          p {
            width: 388px;
            height: 130px;
            font-size: 16px;
            line-height: 26px;
          }
          .icon {
            margin: 24px 0px;
            display: flex;
            align-items: center;
            img {
              width: 40px;
              height: 40px;
              margin-right: 24px;
            }
          }
        }
        .mapbox {
          .map {
            width: 600px;
            height: 519px;
            background: #8f8f8f;
          }
        }
      }
    }
  }
}
</style>
